import { Controller } from "@hotwired/stimulus"

// Flash toast — auto-dismisses after 4s. Close button triggers immediate dismiss.
export default class extends Controller {
  connect() {
    this.timeout = setTimeout(() => this.dismiss(), 4000)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  dismiss() {
    if (this.timeout) clearTimeout(this.timeout)
    this.element.style.transition = "opacity 0.3s ease, transform 0.3s ease"
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(10px)"
    setTimeout(() => {
      // Hide the whole container if this was the last toast
      const container = document.getElementById("flash-toast-container")
      if (container) {
        this.element.remove()
        if (container.children.length === 0) container.remove()
      }
    }, 350)
  }
}
